import React from 'react';

import BuildDetailsGrid from '../components/BuildDetailsGrid';

import { L2ContractDetailsModule } from './BuildDetailsTokenInfoL2ContractModule';

const BuildDetailsTokenInfoL2ContractModuleInstanceParameters: React.FC<{
  module: L2ContractDetailsModule;
}> = ({ module }) => {
  if (!module?.instance) return null;

  const { parameters } = module.instance;

  return (
    <BuildDetailsGrid>
      <span>Instance Parameters</span>

      <div className="bg-background/50 max-w-full overflow-x-auto rounded-xl px-4 py-2 text-[8px]">
        <pre>{JSON.stringify(parameters, null, 2)}</pre>
      </div>
    </BuildDetailsGrid>
  );
};

export default BuildDetailsTokenInfoL2ContractModuleInstanceParameters;
